export default __webpack_public_path__ + "static/iot-feature-image1-19cdad23e98ad8db27dda3ae5d220409.png";